import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e3de46a6")

_pushScopeId("data-v-e3de46a6")
const _hoisted_1 = { class: "liquidationContainer gt-sm" }
const _hoisted_2 = { class: "ObligationInfo" }
const _hoisted_3 = { class: "obligation" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "first" }
const _hoisted_6 = {
  class: "second",
  style: {"text-align":"center"}
}
const _hoisted_7 = {
  class: "second",
  style: {"padding-right":"10px"}
}
const _hoisted_8 = {
  class: "second",
  style: {"text-align":"center","transform":"translateX(30px)"}
}
const _hoisted_9 = { class: "second" }
const _hoisted_10 = { class: "second" }
const _hoisted_11 = { class: "last" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "tableContent" }
const _hoisted_14 = { class: "first" }
const _hoisted_15 = {
  class: "second",
  style: {"text-align":"center"}
}
const _hoisted_16 = { style: {"width":"100%","height":"100%","position":"relative","display":"flex","justify-content":"center"} }
const _hoisted_17 = {
  class: "second",
  style: {"padding-right":"10px"}
}
const _hoisted_18 = {
  class: "second",
  style: {"text-align":"center","transform":"translateX(30px)"}
}
const _hoisted_19 = { style: {"width":"100%","height":"100%","position":"relative","display":"flex","justify-content":"center"} }
const _hoisted_20 = { class: "second" }
const _hoisted_21 = { class: "last" }
const _hoisted_22 = {
  key: 0,
  class: "diver"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { style: {"width":"100%","display":"flex"} }
const _hoisted_25 = { class: "first" }
const _hoisted_26 = {
  class: "second",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_27 = {
  class: "second",
  style: {"display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_28 = {
  class: "second",
  style: {"margin-left":"25px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_29 = {
  class: "second",
  style: {"display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_30 = {
  class: "first",
  style: {"margin-left":"25px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_31 = {
  class: "first",
  style: {"margin-left":"3%","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_32 = { class: "liquidationMobileContainer lt-md " }
const _hoisted_33 = { class: "title-wrap" }
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "content-wrap" }
const _hoisted_36 = {
  key: 0,
  class: "table-wrap"
}
const _hoisted_37 = { class: "table-item" }
const _hoisted_38 = { style: {"padding-bottom":"10px"} }
const _hoisted_39 = { class: "account-wrap" }
const _hoisted_40 = { class: "ratio-wrap" }
const _hoisted_41 = { class: "app-icon-wrap" }
const _hoisted_42 = { class: "amount-wrap" }
const _hoisted_43 = { class: "app-icon-wrap" }
const _hoisted_44 = { style: {"padding-bottom":"15px"} }
const _hoisted_45 = { class: "amount-wrap" }
const _hoisted_46 = {
  key: 1,
  class: "table-wrap"
}
const _hoisted_47 = { class: "table-item" }
const _hoisted_48 = { style: {"padding-bottom":"10px"} }
const _hoisted_49 = {
  class: "account-wrap",
  style: {"border":"none","padding":"0","border-radius":"10px"}
}
const _hoisted_50 = {
  class: "ratio-wrap",
  style: {"width":"15%","height":"100%"}
}
const _hoisted_51 = { style: {"margin":"16px 0"} }
const _hoisted_52 = { class: "app-icon-wrap" }
const _hoisted_53 = {
  class: "amount-wrap",
  style: {"width":"20%","height":"100%"}
}
const _hoisted_54 = { style: {"margin":"16px 0"} }
const _hoisted_55 = { class: "app-icon-wrap" }
const _hoisted_56 = { style: {"padding-bottom":"15px"} }
const _hoisted_57 = {
  class: "amount-wrap",
  style: {"width":"20%"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LiquidateDialog = _resolveComponent("LiquidateDialog")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_skeleton = _resolveComponent("q-skeleton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.$store.state.dialog.liquidateDialogVisible)
      ? (_openBlock(), _createBlock(_component_LiquidateDialog, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", null, _toDisplayString(_ctx.t('liquidation.liquidation')), 1),
              (_ctx.needToHandle)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    "no-caps": "",
                    class: "title-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openHandleLpDialog()))
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('home.unsettledAssets')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", {
              class: "tableHeader",
              style: ['ru'].includes(_ctx.$i18n.locale)?'font-size:14px':''
            }, [
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('liquidation.account')) + " ID", 1),
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('liquidation.assetsToRepay')), 1),
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('liquidation.maxRepayAmount')), 1),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.t('liquidation.assetsToSeize')), 1),
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t('liquidation.maxSeizeAmount')), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('liquidation.debtRatio')), 1),
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('liquidation.action')), 1)
            ], 4),
            (!_ctx.isLoadingInfo)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allUserObligations, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: item.id,
                      style: {"padding-bottom":"15px"}
                    }, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("span", null, _toDisplayString(item.info.owner.toString().substr(0, 4)) + "..." + _toDisplayString(item.info.owner.toString().substr(-4, 4)), 1)
                        ]),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("div", _hoisted_16, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.info.sortBorrows, (borrow) => {
                              return (_openBlock(), _createBlock("div", {
                                key: borrow.id,
                                style: {"width":"28px"}
                              }, [
                                _createVNode("img", {
                                  src: borrow.reserve.logoSource,
                                  width: 38,
                                  height: "38",
                                  alt: ""
                                }, null, 8, ["src"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createVNode("div", _hoisted_17, [
                          _createVNode("p", null, _toDisplayString(_ctx.setMaxRepayAmount(item.info.sortBorrows).toFixed(2)) + " " + _toDisplayString(item.info.sortBorrows[0].reserve.info.liquidity.name), 1),
                          _createVNode("span", null, " $" + _toDisplayString(_ctx.getMaxRepayValue(item.info.sortBorrows).toFixed(2)), 1)
                        ]),
                        _createVNode("div", _hoisted_18, [
                          _createVNode("div", _hoisted_19, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.info.sortDeposits, (deposit) => {
                              return (_openBlock(), _createBlock("div", {
                                key: deposit.id,
                                style: {"width":"28px"}
                              }, [
                                _createVNode("img", {
                                  src: deposit.reserve.logoSource,
                                  width: deposit.isLP?'70':'38',
                                  height: "38",
                                  alt: ""
                                }, null, 8, ["src", "width"])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createVNode("div", _hoisted_20, [
                          _createVNode("p", null, _toDisplayString(_ctx.getMaxSeizeAmount(item.info.sortBorrows[0],item.info.sortDeposits[0]).toFixed(2)) + " " + _toDisplayString(item.info.sortDeposits[0].reserve.info.liquidity.name), 1),
                          _createVNode("span", null, " $" + _toDisplayString(_ctx.getMaxSeizeValue(item.info.sortBorrows[0],item.info.sortDeposits[0]).toFixed(2)), 1)
                        ]),
                        _createVNode("div", {
                          class: "second",
                          style: _ctx.getDebtRatioStyle(item.info.debtRatio)
                        }, _toDisplayString(item.info.debtRatio.times(100).toFixed(2)) + "% ", 5),
                        _createVNode("div", _hoisted_21, [
                          _createVNode(_component_q_btn, {
                            class: ["buttonAble", {'button-disable':item.info.debtRatio.isLessThan(1)}],
                            onClick: ($event: any) => (_ctx.openLiquidateDialog(item))
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('liquidation.liquidate')), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick"])
                        ])
                      ]),
                      (index+1!==_ctx.allReservesDetails.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_22))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isLoadingInfo||_ctx.loadingLiquidationData&&_ctx.firstOpen)
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (i) => {
                    return _createVNode("div", {
                      class: "tableContent",
                      key: i ,
                      style: {"opacity":"0.5"}
                    }, [
                      _createVNode("div", _hoisted_24, [
                        _createVNode("div", _hoisted_25, [
                          _createVNode(_component_q_skeleton, {
                            variant: "text",
                            style: {"width":"100%","height":"75%","margin-top":"0","border-radius":"18px"}
                          })
                        ]),
                        _createVNode("div", _hoisted_26, [
                          _createVNode(_component_q_skeleton, { type: "QAvatar" })
                        ]),
                        _createVNode("div", _hoisted_27, [
                          _createVNode(_component_q_skeleton, {
                            variant: "text",
                            style: {"width":"100%","height":"75%","margin-top":"0","border-radius":"18px"}
                          })
                        ]),
                        _createVNode("div", _hoisted_28, [
                          _createVNode(_component_q_skeleton, { type: "QAvatar" })
                        ]),
                        _createVNode("div", _hoisted_29, [
                          _createVNode(_component_q_skeleton, {
                            variant: "text",
                            style: {"display":"flex","width":"100%","height":"75%","margin-top":"0","border-radius":"18px"}
                          })
                        ]),
                        _createVNode("div", _hoisted_30, [
                          _createVNode(_component_q_skeleton, {
                            variant: "text",
                            style: {"display":"flex","width":"100%","height":"75%","margin-top":"0","border-radius":"18px"}
                          })
                        ]),
                        _createVNode("div", _hoisted_31, [
                          _createVNode(_component_q_skeleton, {
                            variant: "text",
                            style: {"display":"flex","width":"80%","height":"75%","margin-top":"0","border-radius":"18px"}
                          })
                        ])
                      ])
                    ])
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_32, [
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, "LARIX " + _toDisplayString(_ctx.t('liquidation.liquidation')), 1),
        (_ctx.needToHandle)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              "no-caps": "",
              class: "title-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openHandleLpDialog()))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('home.unsettledAssets')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_35, [
        (!_ctx.isLoadingInfo)
          ? (_openBlock(), _createBlock("div", _hoisted_36, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allUserObligations, (item) => {
                return (_openBlock(), _createBlock("div", {
                  key: item.id
                }, [
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _createVNode("div", null, _toDisplayString(_ctx.t('liquidation.account')) + " ID", 1),
                        _createVNode("div", null, _toDisplayString(item.info.owner.toString().substr(0, 6)) + "..." + _toDisplayString(item.info.owner.toString().substr( item.info.owner.toString().length - 4, 4)), 1)
                      ]),
                      _createVNode("div", _hoisted_40, [
                        _createVNode("div", {
                          style: _ctx.getDebtRatioStyle(item.info.debtRatio)
                        }, _toDisplayString(item.info.debtRatio.times(100).toFixed(2)) + "%", 5),
                        _createVNode("div", null, _toDisplayString(_ctx.t('liquidation.debtRatio')), 1)
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", null, _toDisplayString(_ctx.t('liquidation.assetsToRepay')), 1),
                      _createVNode("div", _hoisted_41, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.info.sortBorrows, (borrow) => {
                          return (_openBlock(), _createBlock("div", {
                            key: borrow.id
                          }, [
                            _createVNode("img", {
                              src: borrow.reserve.logoSource,
                              width: "21",
                              alt: ""
                            }, null, 8, ["src"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", null, _toDisplayString(_ctx.t('liquidation.maxRepayAmount')), 1),
                      _createVNode("div", _hoisted_42, [
                        _createVNode("div", null, _toDisplayString(_ctx.setMaxRepayAmount(item.info.sortBorrows).toFixed(2)) + _toDisplayString(item.info.sortBorrows[0].reserve.info.liquidity.name), 1),
                        _createVNode("div", null, "$" + _toDisplayString(_ctx.getMaxRepayValue(item.info.sortBorrows).toFixed(2)), 1)
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", null, _toDisplayString(_ctx.t('liquidation.assetsToSeize')), 1),
                      _createVNode("div", _hoisted_43, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.info.sortDeposits, (deposit) => {
                          return (_openBlock(), _createBlock("div", {
                            key: deposit.id
                          }, [
                            _createVNode("img", {
                              src: deposit.reserve.logoSource,
                              width: "21",
                              alt: ""
                            }, null, 8, ["src"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", null, _toDisplayString(_ctx.t('liquidation.maxSeizeAmount')), 1),
                      _createVNode("div", _hoisted_45, [
                        _createVNode("div", null, _toDisplayString(_ctx.getMaxSeizeAmount(item.info.sortBorrows[0],item.info.sortDeposits[0]).toFixed(2)) + " " + _toDisplayString(item.info.sortDeposits[0].reserve.info.liquidity.name), 1),
                        _createVNode("div", null, "$" + _toDisplayString(_ctx.getMaxSeizeValue(item.info.sortBorrows[0],item.info.sortDeposits[0]).toFixed(2)), 1)
                      ])
                    ]),
                    _createVNode(_component_q_btn, {
                      class: ["liquidate-button", {'button-disable':item.info.debtRatio.isLessThan(1)}],
                      onClick: ($event: any) => (_ctx.openLiquidateDialog(item))
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('liquidation.liquidate')), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isLoadingInfo||_ctx.loadingLiquidationData&&_ctx.firstOpen)
          ? (_openBlock(), _createBlock("div", _hoisted_46, [
              _createVNode("div", _hoisted_47, [
                _createVNode("div", _hoisted_48, [
                  _createVNode("div", _hoisted_49, [
                    _createVNode(_component_q_skeleton, {
                      variant: "text",
                      style: {"width":"100%","height":"100%"}
                    })
                  ]),
                  _createVNode("div", _hoisted_50, [
                    _createVNode(_component_q_skeleton, {
                      variant: "text",
                      style: {"width":"100%","height":"100%"}
                    }),
                    _createVNode(_component_q_skeleton, {
                      variant: "text",
                      style: {"width":"100%","height":"80%","margin-top":"8px"}
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_51, [
                  _createVNode(_component_q_skeleton, {
                    variant: "text",
                    style: {"width":"15%","height":"100%"}
                  }),
                  _createVNode("div", _hoisted_52, [
                    _createVNode("div", null, [
                      _createVNode(_component_q_skeleton, {
                        type: "QAvatar",
                        style: {"height":"21px","width":"21px"}
                      })
                    ])
                  ])
                ]),
                _createVNode("div", null, [
                  _createVNode(_component_q_skeleton, {
                    variant: "text",
                    style: {"width":"20%","height":"100%"}
                  }),
                  _createVNode("div", _hoisted_53, [
                    _createVNode(_component_q_skeleton, {
                      variant: "text",
                      style: {"width":"100%","height":"100%"}
                    }),
                    _createVNode(_component_q_skeleton, {
                      variant: "text",
                      style: {"width":"100%","height":"80%","margin-top":"8px"}
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_54, [
                  _createVNode(_component_q_skeleton, {
                    variant: "text",
                    style: {"width":"13%","height":"100%"}
                  }),
                  _createVNode("div", _hoisted_55, [
                    _createVNode("div", null, [
                      _createVNode(_component_q_skeleton, {
                        type: "QAvatar",
                        style: {"height":"21px","width":"21px"}
                      })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_56, [
                  _createVNode(_component_q_skeleton, {
                    variant: "text",
                    style: {"width":"20%","height":"100%"}
                  }),
                  _createVNode("div", _hoisted_57, [
                    _createVNode(_component_q_skeleton, {
                      variant: "text",
                      style: {"width":"100%","height":"100%"}
                    }),
                    _createVNode(_component_q_skeleton, {
                      variant: "text",
                      style: {"width":"100%","height":"80%","margin-top":"8px"}
                    })
                  ])
                ]),
                _createVNode(_component_q_skeleton, {
                  variant: "text",
                  style: {"width":"100%","height":"100%"}
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
})